const blop = require("!/Users/batistebieler/project/blop-language/src/runtime.js");
let TodoListItem;

TodoListItem = (attributes, _children) => {let hooks, __6;
  let { value, changeItem: change, removeItem, editItem, editMode
  } = attributes;


  hooks = ({
    insert: (vnode) => {
      vnode.elm.focus();
      vnode.elm.select();
    }
  });
  const __1c = []; const __1a = {}; __1a['style'] = ({ marginBottom: '5px' });
    const __2c = []; const __2a = {}; __2a['class'] = 'form-row';
      const __3c = []; const __3a = {}; __3a['class'] = 'col';
        if (editMode) {
          const __4c = []; const __4a = {}; __4a['hooks'] = hooks; __4a['class'] = 'form-control'; __4a['type'] = 'text'; __4a['value'] = value; __4a['on'] = ({ change }); const __4 = blop.h('input', __4a, __4c); __3c.push(__4);
        } else {
          const __5c = []; const __5a = {}; __5a['on'] = ({ click: editItem }); __5a['style'] = ({ padding: '10px' });
            __6 = value; Array.isArray(__6) ? __5c.push(...__6) : __5c.push(__6); ;
           const __5 = blop.h('div', __5a, __5c); __3c.push(__5);
        }
       const __3 = blop.h('div', __3a, __3c); __2c.push(__3);
      const __7c = []; const __7a = {}; __7a['class'] = 'col';
        const __8c = []; const __8a = {}; __8a['class'] = 'btn btn-secondary'; __8a['on'] = ({ click: removeItem }); const __9 = 'delete'; Array.isArray(__9) ? __8c.push(...__9) : __8c.push(__9); const __8 = blop.h('button', __8a, __8c); __7c.push(__8);
       const __7 = blop.h('div', __7a, __7c); __2c.push(__7);
     const __2 = blop.h('div', __2a, __2c); __1c.push(__2);
   const __1 = blop.h('li', __1a, __1c); return __1;
};


module.exports = { TodoListItem };
